import { render, staticRenderFns } from "./ManualPantalla.vue?vue&type=template&id=39366acf&scoped=true"
import script from "./ManualPantalla.vue?vue&type=script&lang=js"
export * from "./ManualPantalla.vue?vue&type=script&lang=js"
import style0 from "./ManualPantalla.vue?vue&type=style&index=0&id=39366acf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39366acf",
  null
  
)

export default component.exports